class ProductImages extends HTMLElement {
  constructor() {
    super();
    this.sliderEl = this.querySelector('[data-slider]');
    this.thumbsEl = this.querySelector('[data-thumbs]');
    this.init();
  }

  handleVariantChange(event) {
    if(!this.slider) return;

    const allSlides = Array.from(this.sliderEl.querySelectorAll('.slide'));
    if(!allSlides?.length > 0) {
      return console.error("Cant display variant image, no slide found.");
    };

    const targetSlideIndex = allSlides.findIndex(slide => slide.dataset.imageVariant == event.detail.variant_id);
    if(targetSlideIndex === null || targetSlideIndex === undefined) {
      return console.error("No variant image found");
    };

    this.slider.slideTo(targetSlideIndex);
  }

  startImagesSlider() {
    if(!this.sliderEl || !this.thumbs) return;
    
    this.slider = new Swiper(this.sliderEl, {
      loop: true,
      spaceBetween: 10,
      thumbs: {
        swiper: this.thumbs,
      },
      navigation: {
        prevEl: '.images-slider__button.prev',
        nextEl: '.images-slider__button.next',
      }
    });
  }

  enableImageZoom() {
    const slides = this.sliderEl.querySelectorAll('[data-slide-media-type="image"');
    if(!slides?.length > 0) return;

    // Zooming utility function
    function zoomIn(event) {
      let zoomEl = event.currentTarget.querySelector('img');
      let offsetX, offsetY;
    
      // Get offsetX and offsetY based on mouse or touch event
      if (event.offsetX) {
        offsetX = event.offsetX;
      } else {
        offsetX = event.touches[0].pageX - zoomEl.getBoundingClientRect().left;
      }
    
      if (event.offsetY) {
        offsetY = event.offsetY;
      } else {
        offsetY = event.touches[0].pageY - zoomEl.getBoundingClientRect().top;
      }
    
      let x = (offsetX / zoomEl.offsetWidth) * 100;
      let y = (offsetY / zoomEl.offsetHeight) * 100;
    
      zoomEl.style.transformOrigin = `${x}% ${y}%`;
    }

    slides.forEach(slide => {
      slide.addEventListener('click', function(event) {
        event.preventDefault();
        const image = slide.querySelector('img');
    
        if (slide.classList.contains('zoom-in')) {
          // Zoom out: reset image transformation and styles
          image.style.transform = 'scale(1)';
          slide.classList.remove('zoom-in');
    
          // Remove mousemove event if not zooming
          slide.removeEventListener('mousemove', zoomIn);
        } else {
          // Zoom in: scale the image and adjust cursor position
          image.style.transform = 'scale(2)';
          slide.classList.add('zoom-in');
          zoomIn(event); // Once clicked, zoom at mouse position
    
          // Add mousemove event
          slide.addEventListener('mousemove', zoomIn);
        }
      });
    });
  }

  startThumbsSlider() {
    if(!this.thumbsEl) return;
    
    this.thumbs = new Swiper(this.thumbsEl, {
      slidesPerView: 4,
      spaceBetween: 12,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          direction: 'vertical'
        },
      },
    });
  }

  init() {
    this.startThumbsSlider();
    this.startImagesSlider();
    document.addEventListener('variantChanged', this.handleVariantChange.bind(this));
    this.enableImageZoom();
  }
}

if(!customElements.get('product-images')) {
  customElements.define('product-images', ProductImages);
}